export const INIT = 'app/CausesPage/INIT';
export const INIT_SUCCESS = 'app/CausesPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/CausesPage/INIT_FAILED';
export const SET_SEARCH = 'app/CausesPage/SET_SEARCH';
export const ADD_NEW = 'app/CausesPage/ADD_NEW';

export interface InitAction {
  type: typeof INIT;
}

export const initAction = (causesType?: string) => ({
  type: INIT,
  causesType,
});
export const initSuccessAction = () => ({
  type: INIT_SUCCESS,
});
export const initFailedAction = (error: Error) => ({
  type: INIT_FAILED,
  error,
});

export const setSearchAction = (search) => ({
  type: SET_SEARCH,
  search,
});

export interface AddNewAction {
  type: typeof ADD_NEW;
}
export const addNewAction = (): AddNewAction => ({
  type: ADD_NEW,
});
